module.exports = __webpack_public_path__ + "static/masonry-image-8-ad25c46d4565189d3533eafd8a20c2e5.jpg";